import { render, staticRenderFns } from "./school-list-page.vue?vue&type=template&id=58831b64&"
import script from "./school-list-page.vue?vue&type=script&lang=js&"
export * from "./school-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports